import * as React from 'react';
import { Helmet } from 'react-helmet'
import {useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import rosey2 from '../pics/rosey2.png'

const useStyles = makeStyles((theme) => ({
    body: {
        marginTop: '2vmin',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '5vh'
    },
    titleContainer: {
        [theme.breakpoints.down('md')]: {
            fontSize: '10vmin',
            paddingBottom: '7vmin',
            textShadow: 'black 0px 0 0px',
            WebkitTextStroke: '0px',
        },
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'oswald',
        color: '#5a2a20',
        fontSize: '8vmin',
        paddingBottom: '4vmin',
        WebkitTextStroke: '2px',
        WebkitTextStrokeColor: '#b68f72',
        textShadow: 'black 1px 0 5px'
    },
    title: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '7vmin',
            paddingBottom: '3vh',
            textShadow: 'black 0px 0 0px',
        },
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#b68f72',
        fontWeight: 'bold',
        fontFamily: 'oswald',
        fontSize: '5vmin',
        textShadow: 'black 1px 0 5px',
        marginBottom: '3%'

    },
    author: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '4vmin',
            paddingBottom: '1vh'
        },
        display: 'flex',
        alignItems: 'center',
        color: '#b68f72',
        fontFamily: 'arimo, sans serif',
        fontSize: '2.5vmin'
    },
    date:{
        [theme.breakpoints.down('sm')]: {
            fontSize: '4vmin',
            paddingBottom: '1vh'
        },
        
        display: 'flex',
        alignItems: 'center',
        color: '#b68f72',
        fontFamily: 'arimo, sans serif',
        fontSize: '2.5vmin',
        marginBottom: '1vh'
    },
    authorPic: {
        [theme.breakpoints.down('sm')]: {
            
        },
        height: 'auto',
        width: '20vmin',
        borderRadius: '50%',
        marginLeft: '5%'
    },
    blogHolder: {
        [theme.breakpoints.down('sm')]: {
            width: '90vw'
        },
        width: '50vw',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#5a2a20',
        boxShadow: '0 0 5px -1px rgba(0,0,0,0.6)',
        borderRadius: '10px',
        paddingLeft: '2vw',
        paddingRight:'2vw',
    },
    blog: {
        [theme.breakpoints.down('xs')]: {
           fontSize: '4vmin'
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            fontSize: '4vmin'
        },
        fontSize: '2vmin',
        marginTop: '2vh',
        width: '100%',
        
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '1vh',
        color: 'white',
        fontSize: '2vmin',
        fontFamily: "Open Sans, sans-serif",
        marginBottom: '2vh'
    },
    blogPicContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '2%',
        display: 'flex',
        flexDirection: 'column',
        color: '#5a2a20',
    },
    postPic:{
        [theme.breakpoints.down('sm')]: {
            width: '50%',
            marginBottom: '3vh',
            marginTop: '2vh'
        },
        [theme.breakpoints.down('sm')]: {
            width: '50%',
            marginBottom: '3vh',
            marginTop: '2vh'
        },
        float: 'right',

        width: '40%',
        marginLeft: '2vw',
        marginBottom: '1vh'
    },
    postBio: {
        fontStyle: 'italic'
    },
    divider: {
        borderBottom: '5px solid white',
        marginBottom: '2vw'
    }

}))

const BlogTwo = ({ crossroads, setCrossroads }) => {

    useEffect(() => {
        setCrossroads(false)
    }, [])

    const classes = useStyles()


    return (
        <>
            <div className={classes.body}>
            <Helmet>
                <title>BLOG</title>
                <meta
                    name="description"
                    content="Read Blog Articles related to Remembering The Future"
                />
            </Helmet>
                <div className={classes.titleContainer}>
                    The Things Book People Discuss
                </div>
                <div className={classes.blogHolder}>

                    <div className={classes.post}>
                        <div className={classes.title}>
                            The Things People Discuss
                        </div>
                        <div className={classes.authorandDate}>
                            <div className={classes.author}>By Rosey Sembatya </div>
                            <div className={classes.date}>7/5/26</div>
                        </div>
                        <div className={classes.blog}>

                                <img className={classes.postPic} src={rosey2}></img>
                                If you have never been around writers, let me tell you what writers talk about when
                                they meet. Hold on: This may make you dizzy.
                                <br></br>
                                <br></br>
                                I recently was privileged to meet members of the Growth
                                Lane book club in Entebbe. It was their end-of-the-month
                                meeting, and they were featuring Remembering the
                                Future, a collection of essays that I have been proudly
                                promoting.  The club hosted one of the book’s 12 writers,
                                Mr. Joachim Buwembo, a seasoned journalist and writer
                                and now the chairman of the Uganda Printing and
                                Publishing Corporation, which publishes the Uganda
                                Gazette.
                                <br></br>
                                <br></br>
                                The conversation started before the meeting officially
                                began, gliding through so many topics I had trouble keeping up. It was exciting,
                                though. Like life itself, the conversation was made up of intertwined elements.
                                Even before the MC called us to order, there was talk of Namakula’s place in
                                Kitara, a venue where intense, structured conversations are held on complicated
                                topics. I wondered how the conversation could ever get to the book we were there
                                to discuss and its brain teasing title? I wasn’t sure how we could leap to that
                                question. Would we end up stealing the future we had planned for the day?
                                <br></br>
                                <br></br>
                                Stealing the future seems as nonsensical as remembering it; how can you steal or
                                remember something that doesn’t yet exist? But then the book’s invitation to
                                remember took me back to 1998. If you are Ugandan, that year should be
                                important to you because it was when the decision was made that land would
                                belong to anyone who had occupied it for at least 12 years. From thoughts of 1998,
                                the mind readily jumps further back to 1986, when the NRA captured power and
                                set the 12-year occupancy requirement for land ownership. Even today, if you have
                                been on the land for 40 years and are claiming ownership, your mind is drawn back
                                to 1986, 1998 – and to current times, the “future” that was shaped four decades
                                ago.
                                <br></br>
                                <br></br>
                                As I pondered time, the book club’s conversation somehow moved on to our dear
                                prime minister, who is about to get her PhD without stepping into a lecture room. It
                                jumped to observations that there are fewer mountain gorillas in Rwanda than the
                                Rwandans perceive, and from there members talked about how Arsenal players
                                must visit Rwanda every year for two weeks and tweet about it. Is that a
                                governance issue, a strategic issue, or is it just a matter of love for one’s country?
                                <br></br>
                                <br></br>
                                I think it boils down to love for one’s country. A bigger, fancier term for it is
                                democracy. Suddenly, I saw the connection between these random bits of
                                conversation. Disciplined discussion. Policy. Ethics. The environment in which we
                                live. The various strands of conversation all arose from the effort to understand
                                who we are and, by implication, who we want to become. When the MC called our
                                meeting to order, our guest noted that the Kabaka, by tradition takes on the clan of
                                his mother. Why? So that no clan gets monopoly over becoming Kabaka. All the
                                52 clans know that one day they will get a Kabaka from their clan. Surely, that is
                                democracy in action.

                                <br></br>
                                <br></br>
                                Clans are modelled around animals, and all clan headquarters are on hills and
                                forests, an arrangement that ensures that the clans serve as our environment
                                bodyguards – a vital link, Mr. Buwembo noted, between our past and future.
                                <br></br>
                                <br></br>
                                The conversation moved to how Buganda’s clan system grew from the original five to 52 clans. Most clans came with the Kabakas, who conquered and added them to
                                Buganda. Then the conversation moved to Luganda orthography. Did you know
                                that the largest clan, the Mamba clan (lung fish), is originally from Kenya/Luo?
                                Take the name Mubiru, a common name among the Mamba clan. It was originally
                                Ombiro. But the Luganda orthography doesn’t have O to start any name. So the
                                Baganda decided to delete the O and start with M and add the vowel u to make
                                Mubiru. This was particularly interesting because my daughter’s name is
                                Namubiru. She carries with her a vital piece of our heritage.
                                <br></br>
                                <br></br>
                                The night was closing in. Somehow the discussion moved from our speaker’s
                                experience in Tanzania where he went to write for Kilimo Trust. Much of his work
                                there was about promoting agriculture.  He regaled us with tales of the coast. When
                                the water levels rise by even a centimeter, the soil in the nearby places will get
                                salty. There is no coast talk without Djinn forces. These are powerful forces to
                                which mermaids belong. They can give wealth. Mzee Buwembo witnessed a Djinn
                                exchanging experiences that left him in awe. A people’s heritage lives on in a
                                modern nation.
                                <br></br>
                                <br></br>
                                When book people meet, their conversations may seem unstructured but they can
                                be full of insight. They range from the past to the present, but they are driven by a
                                concern for the future. Our discussants in Entebbe that day spent a lot of time
                                remembering, but they were remembering for a purpose. They were remembering a
                                new future into being.
                                <br></br>
                                <br></br>
                                Despite the ostensible advances women have made, many men – and women – still have a
                                hard time getting accustomed to women occupying spaces outside of the home. The notion
                                of having a female president is laughable to most, even though Speciosa Wandira Kazibwe
                                once served as Vice President. Some members of the elites grumble that affirmative action
                                is “going too far” and is putting boys and men at a disadvantage. In 1990, the government
                                decided to give an extra 1.5 points in admission scores to all female students joining public
                                universities, and the number of female graduates started to increase. At Makerere, the

                                nation’s largest university, the share of females graduated surpassed males for the first time
                                in 2010 and reached around 55% overall in some years after that. But the female rate
                                dropped to a meagre 0.6 percentage points in 2019. Meanwhile, in Parliament, female
                                representation is below 35%, even when seats are set aside for women in every
                                constituency. This, apparently, is Uganda’s definition of going too far.
                                <br></br>
                                <br></br>
                                Moreover, the crop of empowered women makes up only a small, privileged group. The
                                majority is poorer women who have access to resources only via male relatives or husbands
                                and continue to suffer. Burdened with unpaid care work like having almost the sole
                                responsibility for raising children and taking care of the elderly and the sick, they still work
                                on land they do not own. Sometimes they do not even have ownership of what they grow
                                on this land. They also continue to suffer domestic violence at disproportionate rates.
                                Unfortunately, the success of a few visible women, especially those in positions of authority
                                has not translated to gender equality all over the country.
                                <br></br>
                                <br></br>
                                A whole new world has opened up for women, though: We can go to school, occupy
                                legislative office, open businesses, own land and travel the world – all without the approval
                                of a man. It is okay for women to be found everywhere: at the helm of the city council, in a
                                bar at 3 am, in the corner office, on social media yelling “Men are trash!” and organising a
                                Women’s March.
                                <br></br>
                                <br></br>
                                On social media, interactions between men and women have become more and more
                                fraught and combative. Regardless of what a woman posts, she is likely to receive unseemly
                                comments. A cursory glance through the comments on a female celebrity’s photo posted on
                                Twitter includes an unflattering picture posted as if to discredit her beauty, jokes about her
                                having to announce her new clothes, references to her genitalia, and one lone, inexplicable
                                “B**ch.”
                                <br></br>
                                <br></br>
                                Women who identify as feminists and use the internet for activism report higher levels of
                                harassment and online abuse. Insults usually have to do with us being emotional, ugly,
                                unlovable, and unlikely to find men to marry because we are ugly and unlovable.
                                Sometimes, the attacks seem organised, with trolls swarming online like bees. They go
                                beyond insults; trolls sometimes dish out rape and murder threats. A close friend who
                                started posting openly feminist posts on her Facebook page received numerous comments
                                that she is sex- deprived and wishes to be sexually assaulted. A number of men started
                                commenting on her posts, exchanging jokes about this possibility; one of them bizarrely,
                                targeting her nose. Trolls might be easy to dismiss when they are reported in the news as
                                manufactured in a lab to influence various elections, but it is not that simple when they are
                                friends of friends, men who are known to someone you know, who could very easily find
                                you if they tried.
                                <br></br>
                                <br></br>
                                In pop culture, it is perfectly acceptable for men to sing songs that claim women as
                                “property” and for adverts to portray street harassment presented as if it were a normal
                                way for a man to approach a woman. If a woman points out that such stereotypes are
                                harmful to women, she is accused of taking everything too seriously. Yet, this sense of
                                entitlement to the bodies of women really is harmful. I learnt how to walk further away
                                from men in downtown Kampala when I was still a teenager. My friends and I are constantly
                                afraid, or at least wary, that a man may interrupt a good day with a form of violence, from
                                catcalling or groping, to physical or sexual assault.
                                <br></br>
                                <br></br>
                                On the other hand, men mostly express annoyance at being rejected by women, whether
                                that takes the form of refusing a hug or blocking them on social media. Of course, many
                                men in Uganda face some form of oppression depending on their class, sexual orientation or
                                ethnic origin. This, however, does not necessarily translate into an empathetic view of how
                                women navigate a male-dominated world and a commitment to refrain from harming the
                                women they encounter.
                                <br></br>
                                <br></br>
                                In my interactions with men, some of them have expressed dissatisfaction with the place
                                society assigns them. Yet, they are unwilling to go against the grain and give up the power
                                that comes with the societal pressure to be “man enough”. We have all received and
                                absorbed the same messages about masculinity and femininity. Unlearning these narratives
                                can be a painful process, and less attractive to those who mostly benefit from keeping
                                things as they are.
                                <br></br>
                                <br></br>
                                I am an endless optimist. Despite all the problems I see, and how dysfunctional relationships
                                between men and women often seem, I like to think that more and more people are
                                reimagining life outside of the known social script. That means that we can create a new
                                society where men and women can achieve their full potential. Society can relieve men of
                                the burden to dominate and women of the burden to submit, regardless, and allow them to
                                exercise their full humanity. Society can allow women to enjoy full bodily autonomy and
                                agency and live more fulfilling lives. People often say women and men misunderstand each
                                other, but I think dismantling systems that oppress one group will clear up those
                                communication channels.
                                <br></br>
                                <br></br>
                                I know my brother will never hit a woman because he was taught that lesson at an
                                impressionable age with my father’s red slipper. Even better, I know that as we come to see
                                so many women defining themselves without reference to gender roles, he can fathom
                                women as full human beings outside of their “roles” at home. And today, my brother is not
                                afraid to go to the kitchen: That is the progress that will create a better and free society for
                                women and men.
                                <br></br>
                                <br></br>
                                <span className={classes.postBio}>
                                    Ophelia Kemigisha is a feminist activist, human rights lawyer, and writer. She is interested in
                                    infusing radical politics into legal structures in order to fight patriarchal violence and
                                    oppression. She lives in Kampala, Uganda where she reads, dances, and tweets for the
                                    revolution.
                                    <br></br>
                                    <br></br>
                                    “Remembering the Future” has several chapters that address gender relations and roles.
                                    Edna Namara’s “The Bride’s Farewell Song” describes the recollections of a grandmother on
                                    weddings and marriages in the hill country of Rukiga in Western Uganda. Linda Orando’s
                                    “Goria Ubuntu” shares the reflections of her grandfather, a family patriarch, on family and
                                    the roles of men and women in the family’s compound in Asinge in Eastern Uganda. And
                                    Wobusobozi Amooti Kangere shatters stereotypes in “A Tale of Two Matriarchs,” the story of
                                    powerful matriarchs who led his family and community western Uganda’s Ibanda district.

                                </span>
                            </div>
                    </div>

                    <div className={classes.divider}>

                    </div>

                </div>

            </div>
        </>
    );


}

export default BlogTwo;
